import type {PersonProfile} from './people';
import type {Decision} from './storage';
/** 전달 체크 또는 연결된 실제 선물 기록을 근거로만 다시 묻는다. */
export function pendingReactions(decisions:Decision[],people:PersonProfile[],now=new Date()){
 const time=now.getTime();return decisions.filter(decision=>{
  if(!decision.selectedPatternId||decision.outcome?.d7)return false;
  if(decision.prep?.snoozedUntil&&Date.parse(decision.prep.snoozedUntil)>time)return false;
  if(decision.prep?.deliveredAt)return true;
  const gift=people.find(person=>person.id===decision.personId)?.gifts.find(item=>item.direction==='given'&&item.decisionId===decision.id);
  if(!gift)return false;const delivered=new Date(`${gift.date}T00:00:00`).getTime();return Number.isFinite(delivered)&&time-delivered>=7*86400000;
 }).slice(0,2);
}
